var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoriesHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7128_4331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7499 16.2084C14.3499 15.4584 14.7249 14.4834 14.7249 13.3584C14.7249 11.3334 13.4499 10.5084 12.0249 9.6834C11.7999 9.5334 11.7249 9.5334 11.6499 9.5334C11.4999 9.5334 11.3499 9.6834 11.3499 9.9084C11.3499 10.2084 11.6499 10.7334 11.6499 11.4834C11.6499 12.2334 11.5749 11.7834 11.4249 11.7834C10.7499 11.7834 10.4499 8.4084 10.4499 7.4334C10.4499 6.4584 10.2249 6.9084 9.9999 6.9084C9.7749 6.9084 9.8499 6.9084 9.7749 6.9084C7.8249 8.1834 5.99988 10.5834 5.99988 13.2084C5.99988 14.2084 6.0999 15.0648 6.99988 16.2084C6.99988 16.2084 8.1249 17.8584 10.2249 17.8584C12.3249 17.8584 13.7499 16.0584 13.7499 16.0584V16.2084ZM3.0249 10.8834C3.0249 15.3084 6.2499 18.0084 10.2249 18.0084C14.1999 18.0084 16.9749 15.7584 16.9749 12.1584C16.9749 8.5584 16.1499 9.1584 16.1499 7.9584C16.1499 6.7584 16.3749 6.9834 16.3749 6.6834C16.3749 6.2334 15.8499 6.0834 15.4749 6.0834C14.1999 6.0834 13.5249 6.6834 13.2249 7.1334C13.2249 6.9834 13.2249 6.7584 13.2249 6.4584C13.2249 3.8334 13.8249 3.6084 13.8249 3.1584C13.8249 2.7084 13.2249 2.4834 12.3999 2.4834C10.4499 2.4834 8.8749 3.1584 7.8999 4.3584C7.1499 5.2584 6.9249 5.9334 6.8499 6.2334C6.6999 6.0084 6.5499 5.5584 6.4749 5.3334C6.4749 5.1084 6.3249 4.9584 6.0999 4.9584C5.4249 4.9584 3.0249 7.2834 3.0249 10.8834Z",
    stroke: "#292829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7128_4331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(1 1.2085)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesHot);
export default __webpack_public_path__ + "static/media/categories-hot.659e3679c3d36a012c7e8c42dc2cb8f9.svg";
export { ForwardRef as ReactComponent };